import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class GlobalDataSharedService {
  menuExpanded = false;
  receivedExpand: EventEmitter<boolean>;
  constructor() { 
    this.receivedExpand = new EventEmitter<boolean>();
  }
  raiseEvent(menuExpanded: boolean): void {
    this.menuExpanded = menuExpanded;
    this.receivedExpand.emit(this.menuExpanded);
    console.log('After raiseEvent:', this.menuExpanded );
}
getreceivedExpandedFlag(){
  return this.receivedExpand;
}
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/global-data-shared-service.service.ts